import { setupLocale } from './locale';

setupLocale();
